/* ==========================================================================
   Empenzo — Wawak-style color picker & volume pricing
   - Adds a color-code search box + color family filter tabs to any swatch
     fieldset with many values (threads, zippers, ...)
   - Renders live volume-pricing prices for the selected variant
   Idempotent: safe to re-run after the theme re-renders the section.
   ========================================================================== */
(function () {
  'use strict';

  var MIN_SWATCHES = 20; // only enhance big option sets

  var FAMILIES = [
    ['all', 'All'],
    ['black', 'Black'],
    ['blue', 'Blue'],
    ['brown', 'Brown'],
    ['green', 'Green'],
    ['grey', 'Grey'],
    ['orange', 'Orange'],
    ['pink', 'Pink'],
    ['purple', 'Purple'],
    ['red', 'Red'],
    ['white', 'White'],
    ['yellow', 'Yellow']
  ];

  /* ---------- color classification ---------- */

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = 0, s = 0, l = (max + min) / 2;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        default: h = (r - g) / d + 4;
      }
      h *= 60;
    }
    return [h, s, l];
  }

  function classify(r, g, b) {
    var hsl = rgbToHsl(r, g, b);
    var h = hsl[0], s = hsl[1], l = hsl[2];
    if (l >= 0.9 && s <= 0.2) return 'white';
    if (l <= 0.12) return 'black';
    if (s <= 0.12) {
      if (l >= 0.85) return 'white';
      if (l <= 0.2) return 'black';
      return 'grey';
    }
    if (h >= 15 && h < 48 && l < 0.42) return 'brown';
    if (h < 12 || h >= 342) return l > 0.78 && s < 0.75 ? 'pink' : 'red';
    if (h < 42) return 'orange';
    if (h < 68) return 'yellow';
    if (h < 168) return 'green';
    if (h < 258) return 'blue';
    if (h < 300) return 'purple';
    return 'pink';
  }

  function parseRgb(str) {
    var m = /rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/.exec(str || '');
    return m ? [+m[1], +m[2], +m[3]] : null;
  }

  /* ---------- swatch picker enhancement ---------- */

  function labelsOf(fieldset) {
    return Array.prototype.slice.call(fieldset.querySelectorAll('label'));
  }

  function valueOf(label) {
    var input = document.getElementById(label.htmlFor);
    return input ? input.value : (label.textContent || '').trim();
  }

  function applyFilters(state) {
    var visible = 0;
    state.labels.forEach(function (label) {
      var input = document.getElementById(label.htmlFor);
      var okFamily = state.family === 'all' || label.getAttribute('data-wwk-family') === state.family;
      var okSearch = !state.query || valueOf(label).toLowerCase().indexOf(state.query) !== -1;
      var show = okFamily && okSearch;
      label.classList.toggle('wwk-hidden', !show);
      if (input) input.classList.toggle('wwk-hidden', !show);
      if (show) visible++;
    });
    state.count.textContent = visible + '/' + state.labels.length;
    state.noResults.style.display = visible === 0 ? '' : 'none';
  }

  function updateSelectedBadge(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (!legend) return;
    var badge = legend.querySelector('.wwk-selected');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'wwk-selected';
      legend.appendChild(badge);
    }
    var checked = fieldset.querySelector('input:checked');
    badge.textContent = checked ? checked.value : '';
  }

  function enhanceFieldset(fieldset) {
    if (fieldset.getAttribute('data-wwk') === '1') return;
    var labels = labelsOf(fieldset);
    if (labels.length < MIN_SWATCHES) return;
    fieldset.setAttribute('data-wwk', '1');

    // compact scrollable swatch panel (Wawak-style dropdown box)
    if (labels[0].parentElement) {
      labels[0].parentElement.classList.add('wwk-panel');
    }

    // classify each swatch from its rendered background color
    var present = { all: true };
    labels.forEach(function (label) {
      var rgb = parseRgb(label.style.backgroundColor || getComputedStyle(label).backgroundColor);
      if (rgb && !label.style.backgroundImage) {
        var fam = classify(rgb[0], rgb[1], rgb[2]);
        label.setAttribute('data-wwk-family', fam);
        present[fam] = true;
      }
    });

    var state = {
      labels: labels,
      family: 'all',
      query: ''
    };

    var toolbar = document.createElement('div');
    toolbar.className = 'wwk-toolbar';

    // family tabs
    var fams = document.createElement('div');
    fams.className = 'wwk-families';
    FAMILIES.forEach(function (f) {
      if (!present[f[0]]) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wwk-family' + (f[0] === 'all' ? ' wwk-active' : '');
      btn.textContent = f[1];
      btn.setAttribute('data-wwk-fam', f[0]);
      btn.addEventListener('click', function () {
        state.family = f[0];
        fams.querySelectorAll('.wwk-family').forEach(function (b) {
          b.classList.toggle('wwk-active', b === btn);
        });
        applyFilters(state);
      });
      fams.appendChild(btn);
    });

    // search row
    var row = document.createElement('div');
    row.className = 'wwk-search-row';
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'wwk-search';
    input.placeholder = 'Search color # (e.g. 412)';
    input.setAttribute('aria-label', 'Search color number');
    var count = document.createElement('span');
    count.className = 'wwk-count';
    row.appendChild(input);
    row.appendChild(count);

    var noResults = document.createElement('div');
    noResults.className = 'wwk-no-results';
    noResults.textContent = 'No colors match.';
    noResults.style.display = 'none';

    state.count = count;
    state.noResults = noResults;

    input.addEventListener('input', function () {
      state.query = input.value.trim().toLowerCase();
      applyFilters(state);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = labels.filter(function (l) { return !l.classList.contains('wwk-hidden'); })[0];
        if (first) first.click();
      }
    });

    toolbar.appendChild(fams);
    toolbar.appendChild(row);
    toolbar.appendChild(noResults);

    var legend = fieldset.querySelector('legend');
    if (legend && legend.nextSibling) {
      fieldset.insertBefore(toolbar, legend.nextSibling);
    } else {
      fieldset.insertBefore(toolbar, fieldset.firstChild);
    }

    applyFilters(state);
    updateSelectedBadge(fieldset);
    fieldset.addEventListener('change', function () {
      updateSelectedBadge(fieldset);
    });
  }

  /* ---------- volume pricing ---------- */

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function currentVariantPrice(scope) {
    // theme stores each option value's variant JSON next to the inputs
    var checkedInputs = scope.querySelectorAll('variant-radios input:checked, variant-selects option:checked');
    var price = null;
    checkedInputs.forEach(function (el) {
      var id = el.id || el.getAttribute('id');
      if (!id) return;
      var json = scope.querySelector('script[data-resource="' + id + '"]');
      if (json) {
        try {
          var v = JSON.parse(json.textContent);
          if (v && typeof v.price === 'number') price = v.price;
        } catch (e) { /* noop */ }
      }
    });
    return price;
  }

  function renderVolume(block) {
    var tiers;
    try {
      tiers = JSON.parse(block.getAttribute('data-tiers') || '[]');
    } catch (e) {
      return;
    }
    if (!tiers.length) return;

    var base = parseFloat(block.getAttribute('data-base-price'));
    if (isNaN(base)) {
      var section = block.closest('section, .shopify-section') || document;
      base = currentVariantPrice(section);
    }
    if (base == null || isNaN(base)) return;

    // current quantity in the product form
    var sectionEl = block.closest('section, .shopify-section') || document;
    var qtyInput = sectionEl.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var head = ['1+ Each'];
    var prices = [moneyFormat(base)];
    var saves = ['—'];
    var pcts = [0];
    tiers.forEach(function (t) {
      var pct = parseFloat(t.percent) || 0;
      head.push(t.min_qty + '+');
      prices.push(moneyFormat(Math.round(base * (1 - pct / 100))));
      saves.push(pct.toFixed(2) + '%');
      pcts.push(pct);
    });

    // which tier applies at the current quantity?
    var active = 0;
    tiers.forEach(function (t, i) {
      if (qty >= (parseInt(t.min_qty, 10) || 0)) active = i + 1;
    });

    function cls(base, i) {
      return base + (i === active ? ' wwk-now' : '');
    }

    var html = '<table><thead><tr><th>Qty</th>';
    head.forEach(function (h, i) { html += '<th class="' + cls('', i) + '">' + h + '</th>'; });
    html += '</tr></thead><tbody><tr><td>Price</td>';
    prices.forEach(function (p, i) { html += '<td class="' + cls('wwk-vp-price', i) + '">' + p + '</td>'; });
    html += '</tr><tr><td>Save</td>';
    saves.forEach(function (s, i) { html += '<td class="' + cls('wwk-vp-save', i) + '">' + s + '</td>'; });
    html += '</tr></tbody></table>';

    // "your price" line reflecting the current quantity
    var unit = Math.round(base * (1 - pcts[active] / 100));
    html += '<p class="wwk-yourprice">Your price at qty ' + qty + ': <strong>' + moneyFormat(unit) + '</strong> each';
    if (pcts[active] > 0) {
      html += ' <span class="wwk-yourprice-save">(' + pcts[active].toFixed(2) + '% off — applied automatically in cart)</span>';
    } else if (tiers.length) {
      var next = tiers[0];
      html += ' <span class="wwk-yourprice-hint">Add ' + (parseInt(next.min_qty, 10) - qty) + ' more to save ' + parseFloat(next.percent).toFixed(2) + '%</span>';
    }
    html += '</p>';

    var target = block.querySelector('.wwk-volume-table');
    if (target) target.innerHTML = html;

    // swap the main product price for the current tier's unit price.
    // never mutate the theme's own price node (its JS may rewrite it);
    // hide it via a class and show our own sibling element instead.
    var priceEls = sectionEl.querySelectorAll(
      '.price-item--regular, .price__regular .price-item, .product-block-price .price-item, .product-price .price-item'
    );
    priceEls.forEach(function (el) {
      if (el.closest('[data-wwk-volume]') || el.classList.contains('price-item--sale')) return;
      var tag = el.nextElementSibling;
      if (!(tag && tag.hasAttribute && tag.hasAttribute('data-wwk-price'))) tag = null;

      if (active > 0) {
        if (!tag) {
          tag = document.createElement('span');
          tag.setAttribute('data-wwk-price', '');
          tag.className = el.className.replace('wwk-price-hidden', '') + ' wwk-live-price';
          el.parentNode.insertBefore(tag, el.nextSibling);
        }
        var txt = moneyFormat(unit) + ' USD';
        if (tag.textContent !== txt) tag.textContent = txt;
        el.classList.add('wwk-price-hidden');
      } else {
        if (tag) tag.parentNode.removeChild(tag);
        el.classList.remove('wwk-price-hidden');
      }
    });
  }

  /* ---------- boot & re-apply on section re-render ---------- */

  function run() {
    document.querySelectorAll('fieldset.color-swatch').forEach(enhanceFieldset);
    document.querySelectorAll('[data-wwk-volume]').forEach(renderVolume);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects')) {
      schedule();
    }
  });

  // re-render volume pricing when the quantity changes (typed or +/- buttons)
  ['input', 'change', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!e.target) return;
      var isQty = e.target.name === 'quantity';
      var isQtyButton = e.target.closest && e.target.closest('quantity-input, .quantity, [data-quantity]');
      if (isQty || isQtyButton) {
        // let the theme update the input value first
        setTimeout(function () {
          document.querySelectorAll('[data-wwk-volume]').forEach(renderVolume);
        }, 0);
      }
    });
  });
})();
